/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable, Optional } from '@angular/core';
import SockJS from 'sockjs-client';
import { Stomp } from '@stomp/stompjs';
import { KeycloakService } from '@gh/core-auth-keycloak';
import { ENV_BASE_URL } from '@gh/config';

@Injectable()
export class WebSocketService {
  stompClient: any;
  isConnected: boolean;
  failConnected: boolean;
  subscriptions$ = {};

  constructor(@Optional() private keycloak?: KeycloakService) {
    this.connect();
  }

  connect(): void {
    try {
      if (!this.stompClient) {
        const sockJsUrl = `${ ENV_BASE_URL }/webhook/ws?token=Bearer ${ this.keycloak?.token }`;
        this.stompClient = Stomp.over(() => new SockJS(sockJsUrl));
      }
      this.stompClient.debug = () => {};
      this.stompClient.connect({}, (
        () => this.isConnected = true
      ),                       () => {
        this.isConnected = false;
        this.failConnected = true;
        console.log('webSocket connect failed');
        this.connect();
      });
    } catch (error) {
      console.log('webSocket failed ->', error);
      this.isConnected = false;
      this.failConnected = true;
    }
  }

  hasWSConnect(): boolean {
    return !!this.stompClient && this.isConnected;
  }

  on(event: string, callback: (message: { body: string }) => void): void {
    if (!this.failConnected && (
      !this.stompClient || !this.isConnected
    )) {
      setTimeout(() => this.on(event, callback), 1000);
      return;
    }
    setTimeout(() => {
      try {
        this.subscriptions$[event] = this.stompClient.subscribe(event, callback);
      } catch (e) {
        console.log('webSocket subscribe failed');
      }
    },         1000);
  }

  unsubscribe(event: string): void {
    if (this.stompClient && this.stompClient.unsubscribe && this.hasWSConnect()) {
      this.stompClient.unsubscribe(event);
    }
  }

  send(event: string, item: any): void {
    try {
      this.stompClient.send(event, {}, JSON.stringify(item));
    } catch (e) {
      console.log('webSocket send failed');
    }
  }
}
